import React from 'react';
import ValidatedInput from '../../../../../../common/components/ValidatedInput';

const TextBox = props => {
  return (
    <ValidatedInput
      {...props}
      validation={[
        {
          checkValid: value => value.length <= 30,
          restrictInput: true,
          events: ['onChange'],
        },
      ]}
    />
  );
};

export default TextBox;



// WEBPACK FOOTER //
// ./src/App/account/components/Surveys/QuestionGroup/InputTypes/TextBox.js